export const channelOptions = [
  "WhatsApp",
  "Chrono24",
  "ChronoHunter",
  "Dealer",
  "Facebook",
  "Instagram",
  "LinkedIn",
  "Email",
  "Listing Creation",
];
